<ng-container>
  <div class="front-header-container">
    <div #core_content class="front-header-content">
      <h1
        #title_content
        [title]="localTitle() | trans"
        class="front-header-text front-header-title"
      >
        @if (content()) {
          {{ localTitle() | trans }}
        } @else {
          {{ localTitle() | trans }} : {{ 'Umbrella SIE slogan' | trans }}
        }
      </h1>

      @if (!content() || description()) {
        <div
          [renderHtml]="description() || 'Umbrella SIE desc'"
          class="front-header-text front-header-desc"
        ></div>
      }
    </div>
  </div>
</ng-container>
